module.exports = __webpack_public_path__ + "static/media/YM63_2.69949743.jpg";